import $ from 'jquery';

function openLegalDocument(url) {
  const options = 'width=700,height=800,menubar=false,status=false,toolbar=false,directories=false,scrollbars=yes';
  const termsWindow = window.open(url, 'legal_document', options);
  termsWindow.moveTo(200, 100);
}

function LegalDocumentHandler() {
  $(document).on('click', '.js-open-legal-document', function(e) {
    e.preventDefault();
    openLegalDocument(this.href);
  });
}

export default LegalDocumentHandler;
